import { useEffect, useState } from "react";
import axios from "axios";
import { fetchSimDocumentsToken } from "../../authentication/AuthenticationHelper";
import { ComponentStruct } from "../../common/Interfaces";

interface ModelsParams {
  productCompany: string;
  productRange: string;
  archived: boolean;
}

export function useModels({ productCompany, productRange, archived }: ModelsParams) {
  const [models, setModels] = useState<ComponentStruct[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchModels = async () => {
      const token = await fetchSimDocumentsToken();
      if (token) {
        try {          
          const params =
          {
            ProductCompany: productCompany,
            ProductRange: productRange,
            Archived: archived,
          };
          const config = {
            headers: { Authorization: `Bearer ${token}` },
            params: params
          };
          const apiResponse = await axios.get(
            process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL + "/v1/SIMDocuments/Models",
            config
          );
          const modelList = apiResponse.data.map((model: any) => ({
            key: model.code,
            label: model.code,
          }));
          setModels(modelList);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchModels();
  }, [ productCompany, productRange, archived]);

  return { models, loading };
}